import React, { useState, useEffect } from 'react';
import UDITextField from "./UDITextField.js";

const UnitOfUseDiNumber = ({
	UDI,
	setUDI,
	forceIsEditing = null,
	auxFieldName
}) => {

	const [errorVar, setErrorVar] = useState(false);

	const fieldName = "UnitOfUseDINumber";
	const fieldTitle = "Unit Of Use DI Number";


	const isNullOrEmpty = (val) => {
        return val === "" || val === null;
    }

	const validate = () => {

		setErrorVar(false);

		let value = UDI[fieldName];
        let auxValue = UDI[auxFieldName];

        if (isNullOrEmpty(value) && auxValue > 0) {
            setErrorVar(fieldTitle + " cannot be empty when 'Device Count' is greater than 0"); return false;
        }
    }


	useEffect(() => {

        validate();

	}, [UDI]);


	return <>
		<UDITextField UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} string={true} min={6} max={23} forceIsEditing={forceIsEditing} />

		{errorVar && (
			<div className="view-task-field">
				<div className="view-task-field-line">
					<div className="view-task-field-title"></div>
					<div className="view-task-field-value">
						<span className="form-field-error-message">
							{errorVar}
						</span>
					</div>
				</div>
			</div>
		)}

	</>											  
}


export default UnitOfUseDiNumber;


